import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { processRequestForAccountingArea } from './network/managedRequestForAccountingArea';
import { API } from '../constants';
import { PbRequest } from './pbRequest';
import { PbDispatch } from './index';

type MonthResponse = {
    credit_note_number: string;
    month: number;
    total_gross: number;
    currency_code: string;
    accounting_status: string;
    download_token: string;
};

interface TurnoverStore {
    availableYears: number[];
    turnovers: { [year: number]: MonthResponse[] };
}

const initialState: TurnoverStore = {
    availableYears: [],
    turnovers: {},
};

export const turnoverSlice = createSlice({
    name: 'turnover',
    initialState,
    reducers: {
        setAvailableYears(
            state: TurnoverStore,
            action: PayloadAction<number[]>
        ) {
            state.availableYears = action.payload;
        },
        setTurnover(
            state: TurnoverStore,
            action: PayloadAction<{ year: number; content: MonthResponse[] }>
        ) {
            state.turnovers[action.payload.year] = action.payload.content;
        },
        resetTurnover(
            state: TurnoverStore,
            action: PayloadAction<{ year?: number }>
        ) {
            const year = action.payload?.year;
            if (year) {
                delete state.turnovers[year];
            } else {
                state.turnovers = initialState.turnovers;
            }
        },
    },
});

export const { resetTurnover } = turnoverSlice.actions;

export function LoadTurnoverYears() {
    return async (dispatch: PbDispatch) => {
        dispatch(resetTurnover({}));

        const url = `${API}/turnover/years`;
        const result = await processRequestForAccountingArea<number[]>(
            dispatch,
            url,
            {},
            PbRequest.TURNOVER_LOAD_YEARS
        );

        dispatch(turnoverSlice.actions.setAvailableYears(result));
        return result;
    };
}

export function LoadTurnoverMonths(year) {
    return async (dispatch: PbDispatch) => {
        dispatch(resetTurnover({ year }));

        const url = `${API}/turnover/months/${year}`;
        const result = await processRequestForAccountingArea<MonthResponse[]>(
            dispatch,
            url,
            {},
            PbRequest.TURNOVER_LOAD_MONTHS
        );
        dispatch(turnoverSlice.actions.setTurnover({ year, content: result }));
    };
}

export default turnoverSlice.reducer;
